module.exports = __webpack_public_path__ + "static/media/buy-success.95b7dafb.jpg";